type WallexState = {
  preview: Preview;
  downloadStory: DownloadStory;
  scheduleCall: ScheduleCall;
  trustedBy: TrustedBy;
};

type Preview = {
  title: string;
  description: Array<string>;
}

type DownloadStory = {
  title: string;
  list: Array<string>;
  imageUrl: string;
  iconUrl: string;
}

type ScheduleCall = {
  title: string;
  label: string;
  url: string;
}

type TrustedBy = {
  title: string;
  icons: Array<{
    url: string;
    alt: string;
    height: number;
    width: number;
  }>;
}


type ImagePathBuilderArgs = {
  name: string;
  ext?: string;
  isShared?: boolean;
}

export const imagePathBuilder = (
  {name, ext = 'png', isShared = false}: ImagePathBuilderArgs
) => {
  const basePath = isShared ? '/shared' : '/wallex-leadmagnet-images';
  return `${basePath}/${name}.${ext}`;
}

export const wallexState: WallexState = {
  preview: {
    title: 'Wallex app. An innovative <br><span>e-wallet</span> for safe and convenient <span>cryptocurrency management.</span>',
    description: [
      'Wallex App is an easy-to-use digital crypto-wallet. It is designed for the most efficient management of any cryptocurrency. Users can safely store bitcoins and other cryptocurrencies and perform various transactions and exchange operations with them.',
      'Explore the journey of how Agilie has helped transform Wallex’s vision into a robust and feature-rich mobile crypto-wallet application.'
    ],
  },
  downloadStory: {
    title: 'Download <span>the success story</span> to learn:',
    list: [
      'Background information of the project',
      'The story behind the project',
      'The team involved into the project',
      'UI/UX challenges and ideas',
      'Development challenges to overcome',
      'Technology stack used',
      'Feature list to become a market leader'
    ],
    imageUrl: imagePathBuilder({name: 'wallex-magazine', }),
    iconUrl: imagePathBuilder({name: 'checkmark', ext: 'svg', isShared: true})
  },
  scheduleCall: {
    title: 'Ready to find out how to build your e-wallet app? <span>Book a Discovery call</span> to discuss your needs.',
    label: 'Schedule a call',
    url: '/contacts'
  },
  trustedBy: {
    title: "Trusted by 10+ Fintech companies",
    icons: [
      {
        url: imagePathBuilder({ name: "wirex", ext: 'svg', isShared: true }),
        alt: "Wirex",
        width: 108,
        height: 24,
      },
      {
        url: imagePathBuilder({ name: "wallex", ext: 'svg', isShared: true }),
        alt: "Wallex",
        width: 150,
        height: 28,
      },
      {
        url: imagePathBuilder({ name: "talk-remit", ext: 'svg', isShared: true }),
        alt: "TalkRemit",
        width: 150,
        height: 24,
      },
      {
        url: imagePathBuilder({ name: "lewk", ext: 'svg', isShared: true }),
        alt: "Lewk",
        width: 130,
        height: 28,
      },
      {
        url: imagePathBuilder({ name: "lolypto", ext: 'svg', isShared: true }),
        alt: "Lolypto",
        width: 110,
        height: 32,
      },
      {
        url: imagePathBuilder({ name: "sadad", ext: 'svg', isShared: true }),
        alt: "Sadad",
        width: 66,
        height: 32,
      },
      {
        url: imagePathBuilder({ name: "unknown", ext: 'svg', isShared: true }),
        alt: "Unknown",
        width: 30,
        height: 32,
      },
      {
        url: imagePathBuilder({ name: "gleec", ext: 'svg', isShared: true }),
        alt: "Gleec",
        width: 116,
        height: 28,
      },
    ],
  },
};
